import { Divider, Padding, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import { C2Text, C3Text } from "../../../common/components/text/CustomText";
import { TitleAndInput } from "../../../common/components/input/TitleAndInput";
import { useEffect, useState } from "react";
import CustomModal from "../../../common/components/modal/CustomDetailModal";
import CustomPopup from "../../../common/components/popup/CustomPopup";
import { TitleAndRadio } from "../../../common/components/radio/TitleAndRadio";
import { TitleAndCalendar } from "../../../common/components/calendar/TitleAndCalendar";
import Translate from "../../../common/translate/Translate";
import PrimaryButton from "../../../common/components/button/PrimaryButton";
import SecondaryButton from "../../../common/components/button/SecondaryButton";

const couponTypeOptions = [
    { value: "Free", label: Translate("marketing.type.free") },
    { value: "Discount", label: Translate("marketing.type.discount") },
];
const validShopOptions = [
    { value: "All", label: Translate("marketing.validShop.all") },
    { value: "Shop", label: Translate("marketing.validShop.shop") },
];

const quotaOptions = [
    { value: "Enable", label: Translate("marketing.quota.enable") },
    { value: "Disable", label: Translate("marketing.quota.disable") },
];

const reuseOptions = [
    { value: "Resusable", label: Translate("marketing.reuse.reusable") },
    { value: "Single Use", label: Translate("marketing.reuse.singleUse") },
];

const statusOptions = [
    { value: "Enable", label: Translate("marketing.status.enable") },
    { value: "Disable", label: Translate("marketing.status.disable") },
];

const shopSearchMockValues = [
    { value: "Ram 8 / LGF0001", label: "Ram 8 / LGF0001" },
    { value: "Ram 9 / LGF0002", label: "Ram 9 / LGF0002" },
    { value: "Ram 10 / LGF0003", label: "Ram 10 / LGF0003" },
];

export function MarketingDetailModal({ isOpen, onClose, dto, isSaveMode = false, title }) {
    const [registeredDate, setRegisteredDate] = useState(dto?.registeredDate || "");
    const [couponType, setCouponType] = useState(dto?.couponType || "Free");
    const [couponCode, setCouponCode] = useState(dto?.couponCode || "");
    const [couponName, setCouponName] = useState(dto?.couponName || "");
    const [amount, setAmount] = useState(dto?.amount || "");
    const [validShop, setValidShop] = useState(dto?.validShop || "All");
    const [validPeriod, setValidPeriod] = useState(dto?.validPeriod || "");
    const [quota, setQuota] = useState(dto?.quota || "Enable");
    const [reuse, setReuse] = useState(dto?.reuse || "Resusable");
    const [status, setStatus] = useState(dto?.status || "Enable");
    const [selectedValidShop, setSelectedValidShop] = useState();

    const [isEditMode, setIsEditMode] = useState(isSaveMode);

    useEffect(() => {
        setIsEditMode(isSaveMode);
    }, [isSaveMode]);

    // Confirm Modal
    const [isConfirmPopupOpen, setIsConfirmPopupOpen] = useState(false);

    const handleConfirmClose = () => {
        setIsConfirmPopupOpen(false);
    };

    const handleConfirmOk = () => {
        setIsEditMode(false);
        setIsConfirmPopupOpen(false);
    };

    // Cancel Modal
    const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);
    const [cancelActionType, setCancelActionType] = useState("button");

    const handleCancelClose = () => {
        setIsCancelPopupOpen(false);
    };

    const handleCancelOk = () => {
        setIsCancelPopupOpen(false);

        if (cancelActionType === "modalClose") {
            onClose();
        } else {
            if (isSaveMode) {
                onClose();
            } else {
                setIsEditMode(false);
            }
        }
        setCancelActionType("button");
    };

    return (
        <CustomModal
            title={title}
            isOpen={isOpen}
            onClose={
                isEditMode
                    ? () => {
                          setCancelActionType("modalClose");
                          setIsCancelPopupOpen(true);
                      }
                    : onClose
            }
            width={"552px"}
            side={"right"}
        >
            <SizedBox
                width={"100%"}
                height={"auto"}
                border={"solid 1px #E6E6E9"}
                borderRadius={"16px"}
                alignItem={"flex-start"}
                justifyContent={"flex-start"}
                padding={"22px 0"}
            >
                <Row alignItem={"flex-start"} justifyContent={"space-between"} width={"100%"} padding={"0 20px"}>
                    <C2Text fontWeight={"600"}>{Translate("marketing.coupon")}</C2Text>
                    <C3Text>{registeredDate}</C3Text>
                </Row>
                <SizedBox height={"20px"} />
                <Divider />
                <Padding padding={"20px"} style={{ width: "100%" }}>
                    <TitleAndRadio
                        title={Translate("marketing.couponType")}
                        options={couponTypeOptions}
                        selectedOption={couponType}
                        setSelectedOption={setCouponType}
                        isEditMode={isEditMode}
                    />
                    <Divider marginTop={"23px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                    <TitleAndInput
                        title={Translate("common.code")}
                        type={"normal"}
                        placeholder={Translate("placeholder.shopCode")}
                        dropdownValues={shopSearchMockValues}
                        inputValue={couponCode}
                        setInputValue={setCouponCode}
                        disabled={true}
                    />
                    <Divider marginTop={"11px"} marginBottom={"16px"} lineStyle={"custom-dotted"} />
                    <TitleAndInput
                        title={Translate("common.name")}
                        type={"normal"}
                        placeholder={Translate("placeholder.couponName")}
                        inputValue={couponName}
                        setInputValue={setCouponName}
                        disabled={!isEditMode}
                    />
                    <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                    <TitleAndInput
                        title={Translate("common.amount")}
                        type={"normal"}
                        placeholder={Translate("placeholder.amount")}
                        inputValue={amount}
                        setInputValue={setAmount}
                        disabled={!isEditMode}
                    />
                    <Divider marginTop={"11px"} marginBottom={"23px"} lineStyle={"custom-dotted"} />
                    <TitleAndRadio
                        title={Translate("marketing.validShop")}
                        options={validShopOptions}
                        selectedOption={validShop}
                        setSelectedOption={setValidShop}
                        isEditMode={isEditMode}
                        addItem={isEditMode && validShop === "Shop" && "search"}
                        setSerachSelectedOption={setSelectedValidShop}
                        serachSelectedOption={selectedValidShop}
                        values={shopSearchMockValues}
                    />
                    <Divider marginTop={"23px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                    <TitleAndCalendar
                        title={Translate("marketing.couponValidPeriod")}
                        inputValue={validPeriod}
                        setInputValue={setValidPeriod}
                        disabled={!isEditMode}
                    />
                    <Divider marginTop={"11px"} marginBottom={"23px"} lineStyle={"custom-dotted"} />
                    <TitleAndRadio
                        title={Translate("marketing.quota")}
                        options={quotaOptions}
                        selectedOption={quota}
                        setSelectedOption={setQuota}
                        isEditMode={isEditMode}
                        addItem={quota === "Enable" ? "input" : undefined}
                    />
                    <Divider marginTop={"11px"} marginBottom={"23px"} lineStyle={"custom-dotted"} />
                    <TitleAndRadio
                        title={Translate("marketing.reuse")}
                        options={reuseOptions}
                        selectedOption={reuse}
                        setSelectedOption={setReuse}
                        isEditMode={isEditMode}
                    />
                    <Divider marginTop={"23px"} marginBottom={"23px"} lineStyle={"custom-dotted"} />
                    <TitleAndRadio
                        title={Translate("common.status")}
                        options={statusOptions}
                        selectedOption={status}
                        setSelectedOption={setStatus}
                        isEditMode={isEditMode}
                    />
                </Padding>
            </SizedBox>
            <SizedBox height={"192px"} />
            <Row justifyContent={"flex-end"} width={"100%"}>
                <SecondaryButton
                    text={Translate("common.cancel")}
                    width={"70px"}
                    padding={"7.75px 14.5px"}
                    onClick={() => {
                        if (!isEditMode) {
                            onClose();
                        } else {
                            setIsCancelPopupOpen(true);
                        }
                    }}
                />
                <SizedBox width={"10px"} />
                <PrimaryButton
                    text={Translate("common.save")}
                    width={"70px"}
                    padding={"7.75px 14.5px"}
                    onClick={() => {
                        if (!isEditMode) {
                            setIsEditMode(true);
                        } else {
                            setIsConfirmPopupOpen(true);
                        }
                    }}
                />
            </Row>
            <CustomPopup
                isOpen={isConfirmPopupOpen}
                onClose={handleConfirmClose}
                onConfirm={handleConfirmOk}
                message={Translate("popup.registerCoupon")}
            />
            <CustomPopup
                isOpen={isCancelPopupOpen}
                onClose={handleCancelClose}
                onConfirm={handleCancelOk}
                message={Translate("popup.cancel")}
            />
        </CustomModal>
    );
}
